(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starleva-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sl-site-footer').forEach((footer)=>{
    const floating=document.querySelector('.sl-whatsapp-float');
    if(!floating||footer.dataset.whatsappObserverReady)return;
    footer.dataset.whatsappObserverReady='true';
    const visibleTargets=new Map();
    const refresh=()=>{const compact=window.matchMedia('(max-width:1100px)').matches;const obscured=[...visibleTargets].some(([target,visible])=>visible&&(!target.matches('[data-whatsapp-clearance]')||compact));floating.classList.toggle('is-contact-obscured',obscured)};
    const observer=new IntersectionObserver((entries)=>{
      entries.forEach((entry)=>visibleTargets.set(entry.target,entry.isIntersecting));refresh();
    },{threshold:.01});
    [footer,...document.querySelectorAll('.sl-inquiry'),...document.querySelectorAll('[data-whatsapp-clearance]')].forEach((target)=>observer.observe(target));
    window.addEventListener('resize',refresh,{passive:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starleva-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-responsive-disclosure]').forEach((disclosure)=>{const media=window.matchMedia('(max-width:749px)');const sync=()=>{disclosure.open=!media.matches};sync();media.addEventListener?.('change',sync)});
  document.querySelectorAll('[data-track]').forEach((item)=>{item.addEventListener('click',()=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:item.dataset.track})})});
  document.querySelectorAll('[data-product-demo]').forEach((demo)=>{const reveal=demo.querySelector('[data-video-reveal]');const player=demo.querySelector('[data-video-player]');if(!reveal||!player)return;reveal.addEventListener('click',()=>{reveal.hidden=true;player.hidden=false;const video=player.querySelector('video');if(video)video.play();window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'product_demo_play'})},{once:true})});
  document.querySelectorAll('[data-product-gallery]').forEach((gallery)=>{const main=gallery.querySelector('[data-gallery-main]');gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb)=>{thumb.addEventListener('click',()=>{if(!main)return;main.src=thumb.dataset.src;main.alt=thumb.dataset.alt||'';gallery.querySelectorAll('[data-gallery-thumb]').forEach((item)=>{const active=item===thumb;item.classList.toggle('is-current',active);item.setAttribute('aria-pressed',String(active))})})});const videoThumb=gallery.querySelector('[data-gallery-video]');if(videoThumb)videoThumb.addEventListener('click',()=>document.querySelector('[data-product-demo]')?.scrollIntoView({behavior:'smooth',block:'start'}))});
  document.querySelectorAll('[data-product-configuration]').forEach((panel)=>{
    const choices=panel.querySelectorAll('[data-ink-choice]');
    const toggle=panel.querySelector('[data-ink-toggle]');
    const options=panel.querySelector('[data-ink-options]');
    const selectedTitle=panel.querySelector('[data-selected-ink]');
    const selectedNote=panel.querySelector('[data-selected-ink-note]');
    const sync=()=>{
      const choice=panel.querySelector('[data-ink-choice]:checked');
      if(!choice)return;
      if(selectedTitle)selectedTitle.textContent=choice.dataset.inkTitle||'';
      if(selectedNote)selectedNote.textContent=choice.dataset.inkNote||'';
      const extraModel=panel.querySelector('[data-extra-ink-model]');
      if(extraModel)extraModel.textContent=choice.dataset.inkTitle||'';
    };
    if(toggle&&options)toggle.addEventListener('click',()=>{const open=options.hidden;options.hidden=!open;toggle.setAttribute('aria-expanded',String(open))});
    choices.forEach((choice)=>choice.addEventListener('change',sync));
    panel.querySelectorAll('[data-quantity-stepper]').forEach((stepper)=>{
      const output=stepper.querySelector('[data-quantity-output]');
      const minimum=Number(stepper.dataset.min||0);
      const update=(delta)=>{const value=Math.max(minimum,Number(output.textContent||minimum)+delta);output.textContent=String(value);sync()};
      stepper.querySelector('[data-stepper-minus]')?.addEventListener('click',()=>update(-1));
      stepper.querySelector('[data-stepper-plus]')?.addEventListener('click',()=>update(1));
    });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starleva-products-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-products-hub]').forEach((hub)=>{
    if(hub.dataset.ready)return;hub.dataset.ready='true';
    const disclosure=hub.querySelector('[data-finder-disclosure]');const form=hub.querySelector('[data-finder]');
    const revealFromHash=()=>{if(window.location.hash!=='#setup-finder'||!disclosure)return;disclosure.open=true;requestAnimationFrame(()=>disclosure.scrollIntoView({behavior:'smooth',block:'start'}))};
    revealFromHash();window.addEventListener('hashchange',revealFromHash);if(!form)return;
    const result=form.querySelector('[data-result]');const stale=form.querySelector('[data-result-stale]');let started=false;
    form.addEventListener('change',()=>{if(!started){started=true;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'finder_start'})}if(form.dataset.resultValid==='true'){result.hidden=true;form.dataset.resultValid='false';delete form.dataset.recommendedPrinter;stale.hidden=false;form.dispatchEvent(new CustomEvent('finderstatechange',{bubbles:true}))}});
    form.addEventListener('submit',(event)=>{event.preventDefault();const data=new FormData(form);const material=String(data.get('material')||'other');const priority=String(data.get('priority')||'unsure');const printer=priority==='entry'?'T10':'M10';const review=['plastic','metal','glass','other'].includes(material);form.querySelector('[data-result-title]').textContent=printer;form.querySelector('[data-result-copy]').textContent=review?'Send a material photo or sample so Starleva can confirm the cartridge.':'This model is a starting recommendation for the selected handling preference.';const productLink=form.querySelector('[data-result-product]');productLink.href=printer==='T10'?'/products/t10-handheld-inkjet-printer':'/products/m10-handheld-inkjet-printer';productLink.textContent='Review '+printer;form.dataset.resultValid='true';form.dataset.recommendedPrinter=printer;stale.hidden=true;result.hidden=false;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'finder_result',material:material,printer:printer,result_level:review?'review':'recommended'});form.dispatchEvent(new CustomEvent('finderstatechange',{bubbles:true}));result.scrollIntoView({behavior:'smooth',block:'nearest'})});
  });

  } catch(e) { console.error(e); }
})();
})();
